<template>
  <section>
    <el-row>
      <el-col :span="20">
        <el-form :inline="true" :model="filterForm" class="demo-form-inline">
          <el-form-item label="产品名称：">
            <el-input v-model="filterForm.prod_name" size="small" placeholder="请输入产品名称："></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getProductList">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" size="small" @click="productDialogVisible = true">新增</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" stripe border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="prod_name" label="产品名称" align="center">
      </el-table-column>
      <el-table-column prop="prod_brand" label="产品代号" align="center">
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="160" align="center">
      </el-table-column>
      <el-table-column prop="prod_package" label="包名" align="center">
      </el-table-column>
      <el-table-column prop="prod_version" label="当前版本" align="center" width="80">
      </el-table-column>
      <el-table-column prop="prod_force_update" label="强制更新" align="center" :formatter="formatUpdate" width="80">
      </el-table-column>
      <el-table-column prop="prod_comment" label="备注" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleDelete(scope.row.prod_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" @current-change="changePage" style="text-align:right;margin-top:10px;">
    </el-pagination>
    <el-dialog title="编辑产品" :visible.sync="productDialogVisible" width="30%" :close-on-click-modal="false" :show-close="false"
      :close-on-press-escape="false">
      <el-form label-width="80px" :model="productForm" ref="productForm" :rules="productFormRules">
        <el-form-item label="名称" prop="prod_name">
          <el-input v-model="productForm.prod_name"></el-input>
        </el-form-item>
        <el-form-item label="代号" prop="prod_brand">
          <el-input v-model="productForm.prod_brand"></el-input>
        </el-form-item>
        <el-form-item label="包名" prop="prod_package">
          <el-input v-model="productForm.prod_package"></el-input>
        </el-form-item>
        <el-form-item label="当前版本" prop="prod_version">
          <el-input v-model="productForm.prod_version"></el-input>
        </el-form-item>
        <el-form-item label="强制更新" prop="prod_force_update">
          <el-radio-group v-model="productForm.prod_force_update">
            <el-radio label='1'>是</el-radio>
            <el-radio label='0'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="productForm.prod_comment"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetProductForm" v-loading="handleLoading">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" v-loading="handleLoading">提 交</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
  import {
    getProductList,
    addProduct,
    updateProduct,
    deleteProduct
  } from "../../api";
  export default {
    data() {
      return {
        filterForm: {
          prod_name: ''
        },
        productDialogVisible: false,
        productForm: {
          prod_name: "",
          prod_brand: "",
          prod_package: "",
          prod_comment: "",
          prod_version: "",
          prod_force_update: '0'
        },
        productFormRules: {
          prod_name: [{
            required: true,
            message: "请输入产品名称",
            trigger: "blur"
          }],
          prod_brand: [{
            required: true,
            message: "请输入产品代号",
            trigger: "blur"
          }],
          prod_package: [{
            required: true,
            message: "请输入包名",
            trigger: "blur"
          }],
          prod_version: [{
            required: true,
            message: "请输入版本号",
            trigger: "blur"
          }]
        },
        tableData: [],
        loading: false,
        handleLoading: false,
        total: 0,
        page: 1
      };
    },
    methods: {
      formatUpdate(row) {
        return row.prod_force_update ? "是" : "否";
      },
      handleDelete(id) {
        this.$confirm("此操作将删除该产品, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            deleteProduct(id)
              .then(res => {
                if (res.code) {
                  this.$message({
                    type: "success",
                    message: res.message
                  });
                  this.getProductList();
                }
              })
              .catch(res => {
                this.$message({
                  type: "info",
                  message: "服务器问题，请联系系统管理员！"
                });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      changePage(page) {
        this.page = page;
        this.getProductList();
      },
      handleEdit(item) {
        this.productDialogVisible = true;
        console.log(JSON.stringify(item));
        this.productForm = {
          prod_name: item.prod_name,
          prod_brand: item.prod_brand,
          prod_package: item.prod_package,
          prod_comment: item.prod_comment,
          prod_id: item.prod_id,
          prod_version: item.prod_version,
          prod_force_update: item.prod_force_update+''
        };
      },
      resetProductForm() {
        this.$refs["productForm"].resetFields();
        this.productForm = {
          prod_name: '',
          prod_brand: '',
          prod_package: '',
          prod_comment: '',
          prod_id: '',
          prod_version: "",
          prod_force_update: '0'

        };
        this.productDialogVisible = false;
      },
      handleSubmit() {
        this.$refs["productForm"].validate(valid => {
          if (valid) {
            this.handleLoading = true;
            if (this.productForm.prod_id) {
              updateProduct(this.productForm).then(res => {
                if (res.code == 201) {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                  this.getProductList();
                  this.resetProductForm();
                } else {
                  this.$message.error(res.message);
                }
                this.handleLoading = false;
              });
            } else {
              addProduct(this.productForm).then(res => {
                if (res.code == 201) {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                  this.getProductList();
                  this.resetProductForm();
                } else {
                  this.$message.error(res.message);
                }
                this.handleLoading = false;
              });
            }
          } else {
            this.$message({
              message: "存在必填项未校验通过或者未填写",
              type: "warning"
            });
          }
        });
      },
      getProductList() {
        this.loading = true;
        let para = {
          page: this.page,
          pagesize: this.pagesize,
          keyword: this.filterForm.prod_name
        };
        getProductList(para)
          .then(res => {
            this.loading = false;
            if (res.code == 200) {
              this.tableData = res.data;
              this.total = res.total;
            } else {
              this.$message({
                message: res.message,
                type: "warning"
              });
            }
          })
          .catch(res => {
            this.loading = false;
            this.$message({
              message: "服务器错误，请联系系统管理员！",
              type: "error"
            });
          });
      }
    },
    mounted() {
      this.getProductList();
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/product/index.vue